function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import { get, getDictionaryItem } from '../../utils';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import ListiclePOIs from '../77_ListiclePOIs/ListiclePOIs';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
export const ItineraryPOIsOverview = _ref => {
  let {
    fields,
    rendering,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl); // eslint-disable-line
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.warn('Itenary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[Itenary component is empty: please provide data source or check if any poi is assigned to itenary template]");
    }
    return null;
  }
  const {
    videoAnalytics,
    prevNextNavAnalytics,
    navBubblesAnalytics,
    readMoreAnalytics
  } = fields.data;
  const pois = get(fields, 'data.item.pois.values');
  const dictionaryValues = get(fields, 'data.dictionary');
  const readmore = getDictionaryItem(dictionaryValues, 'ReadMore');
  const renderItems = () => {
    if (pois) {
      return pois.map((item, index) => {
        const fields = {
          fields: {
            data: {
              videoAnalytics,
              prevNextNavAnalytics,
              navBubblesAnalytics,
              readMoreAnalytics,
              item: _objectSpread({}, item)
            }
          },
          params,
          index: index + 1
        };
        return /*#__PURE__*/React.createElement("div", {
          key: index
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ListiclePOIs, _extends({}, fields, {
          readmore: readmore
        }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Placeholder, {
          name: `poi-overview-${index}`,
          rendering: rendering
        })));
      });
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderItems());
};
/* eslint-disable */
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
/* eslint-enable  */

export default ItineraryPOIsOverview;